<script lang="ts" setup>
defineProps<{ item: CommandPaletteItem, active?: boolean }>()
defineEmits<{ (e: 'select', item: CommandPaletteItem): void }>()
</script>

<template>
  <div class="overflow-hidden">
    <div
      class="flex flex-col justify-center group py-2 px-3 h-[55px] cursor-pointer rounded hover:bg-hos-blue hover:text-white"
      :class="{ 'bg-hos-blue text-white': active }"
      @click="$emit('select', item)"
    >
      <div class="flex items-center gap-2">
        <Icon v-if="item.iconName" :name="item.iconName" size="19" />
        <h1 class="grow text-base">
          {{ item.displayLabel }}
        </h1>

        <Icon
          name="material-symbols:subdirectory-arrow-left-rounded"
          size="19"
          :class="active ? 'block' : 'hidden group-hover:block'"
        />
      </div>

      <div class="flex items-center gap-1 ml-7" :class="item.iconName ? 'ml-7' : 'ml-0'">
        <div
          v-for="tag in item.tags"
          :key="tag"
          class="rounded-sm px-1.5 pb-0.5 leading-3"
          :class="{
            'bg-white text-hos-blue': active,
            'bg-hos-blue text-white group-hover:bg-white group-hover:text-hos-blue': !active,
          }"
        >
          <span class="text-[10px]">
            {{ tag }}
          </span>
        </div>
      </div>
    </div>
    <n-divider class="!my-1" />
  </div>
</template>
